import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { ModalService, ConfirmationService, ConfirmationResult, ErrorTranslationService } from '@bayclubs/utils';
import { BayclubsAlertService } from '@bayclubs/alert';

import { camps } from '../../../../models/models.generated';
import { CampsDetailsFormStateService } from '../camp-details-form-state-service';
import { SessionAddComponent } from './sessions-list/session-details/session-basic-info/add/session-add.component';
import { TranslateService } from '@ngx-translate/core';
import { CampManagementApiService } from '../../../../services/api/camp-management-api.service';
import { TabsetComponent } from 'ngx-bootstrap/tabs';

@Component({
    selector: 'app-sessions-group',
    templateUrl: './sessions-group.component.html',
    styleUrls: ['./sessions-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SessionsGroupComponent implements  OnChanges {
    @Input() public form: UntypedFormGroup;

    @Input() context: camps.CampDefinitionCreationContext;

    @ViewChild('tabset') tabset: TabsetComponent;

    constructor(
        public state: CampsDetailsFormStateService,
        private campManagementApi: CampManagementApiService,
        private modalService: ModalService,
        private alert: BayclubsAlertService,
        private translate: TranslateService,
        private confirmationService: ConfirmationService,
        private errorTranslate: ErrorTranslationService
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.form && this.form) {
            const items = this.form.controls.items['controls'];
            const activeIndex = items.findIndex((tab: UntypedFormGroup) => tab.controls.active.value);
            if (activeIndex >= 0) {
                const activeTab = items[activeIndex];
                this.onSelectTab(activeTab);
                if (this.tabset) {
                    setTimeout(() => {
                        this.tabset.tabs[activeIndex].active = true;
                        this.tabset.tabs.forEach((t, i) => {
                            if (i !== activeIndex) t.active = false;
                        });
                    }, 0);
                }
            }
        }
    }

    public onSelectTab(tabControl: any) {
        tabControl.controls.active.setValue(true);

        const items = this.form.controls.items['controls'];
        items.forEach((tab: UntypedFormGroup) => {
            if (tab !== tabControl) {
                tab.controls.active.setValue(false);
            }
        });
    }

    public add() {
        this.modalService
            .create<SessionAddComponent>(SessionAddComponent, { context: this.context, campId: this.form.get('campId').value })
            .subscribe(() => { });
    }

    public get isAnyItemEdited() {
        return this.state.isAnyItemEdited();
    }

    public changeAllowCampCreditPoints() {
        this.confirmationService
            .showTriState(
                this.translate.instant('CampDetails.ChangeCampCreditPointsModalHeader'),
                this.translate.instant('CampDetails.ChangeCampCreditPointsModalText'),
                this.translate.instant('CampDetails.ChangeCampCreditPointsModalSetToFalse'),
                this.translate.instant('CampDetails.ChangeCampCreditPointsModalSetToTrue'),
                this.translate.instant('General.Cancel')
            )
            .subscribe(x => {
                if (x == ConfirmationResult.Action1) {
                    this.saveCreditPointsUsage(false);
                }

                if (x == ConfirmationResult.Action2) {
                    this.saveCreditPointsUsage(true);
                }
            });
    }

    private saveCreditPointsUsage(isAllowed: boolean) {
        var request = <camps.CampCreditPointsUsageSaveRequest>{
            isAllowed: isAllowed,
            campId: this.form.get('campId').value
        };

        this.campManagementApi.saveCreditPointsUsage(request).subscribe(x => {
            if (x.isSuccess) {
                this.alert.showOperationSuccess();
                this.state.sessionChanged.emit(null);
            } else {
                this.errorTranslate.translateValidationNotifications(x.validationNotification);
                this.alert.showError(x.validationNotification.errors[0].message);
            }
        });
    }
}
